import React from 'react';
import { VisuallyHidden } from '@nebula/helpers';
import {
  HeroWrapper,
  HeroCard,
  HeroContent,
  HeroTitleGroup,
  HeroTitle,
  HeroSubtitle,
  HeroPrice,
  CurrentAccountTab,
} from './index.styles';
import type { PlanId } from '../../types';
import { PLAN_CONFIGS } from '../../planData';
import { getSpokenPrice } from '../../utils';

interface PlanCardProps {
  plan: { id: PlanId; cardTitle: string; cardSubtitle: string };
  isCurrent: boolean;
  price: string | null;
}

const PlanCard: React.FC<PlanCardProps> = ({ plan, isCurrent, price }) => {
  const { cardTitle, cardSubtitle } = plan;
  const { gradient, borderColor, borderGradient, textColor } = PLAN_CONFIGS[plan.id];
  const titleId = `plan-card-title-${plan.id}`;

  return (
    // Grouped so the card reads as one unit rather than four loose pieces of text.
    <HeroWrapper role="group" aria-labelledby={titleId}>
      <HeroCard $gradient={gradient} $borderColor={borderColor} $borderGradient={borderGradient}>
        <HeroContent $hasPrice={!!price}>
          <HeroTitleGroup>
            <HeroTitle id={titleId} $textColor={textColor}>
              {cardTitle}
            </HeroTitle>
            <HeroSubtitle $textColor={textColor}>{cardSubtitle}</HeroSubtitle>
          </HeroTitleGroup>
          {price && (
            <>
              <VisuallyHidden>{getSpokenPrice(price)}</VisuallyHidden>
              <HeroPrice $textColor={textColor} aria-hidden="true">
                {price}
              </HeroPrice>
            </>
          )}
        </HeroContent>
      </HeroCard>
      {isCurrent && (
        <CurrentAccountTab>
          <VisuallyHidden>This is your current plan</VisuallyHidden>
          <span aria-hidden="true">Current account</span>
        </CurrentAccountTab>
      )}
    </HeroWrapper>
  );
};

export default PlanCard;
